import { FilterDefinition } from "components/Shared/FilterEditor/utils";
import {
  getDateTimeFilterDefinition,
  getSearchFilterDefinition,
  getStringFilterDefinition,
  SEARCH_FILTER_ID,
} from "components/Shared/FilterEditor/standardFilters";
import { filterDefinitions as bopFilterDefinitions } from "components/Customers/filterDefinitions";
import skuFilterDefinitions from "components/Products/filterDefinitions";
import createNestedFilterDefinitions from "components/Shared/FilterEditor/createNestedFilterDefinitions";
import { assertPresence } from "utils/assertions";
import { makeEnsureType } from "utils/typescriptUtilis";
import { SkuBrandOrderingPlatformFilter } from "__generated__/gql/graphql";

const filterObj = makeEnsureType<SkuBrandOrderingPlatformFilter>();

const skuFilters = createNestedFilterDefinitions("sku", skuFilterDefinitions, {
  groupLabel: "SKU",
});

const skuSearch = skuFilters.find((fd) => fd.id.endsWith(SEARCH_FILTER_ID));

assertPresence(skuSearch);

const brandOrderingPlatformFilters = createNestedFilterDefinitions(
  "brandOrderingPlatform",
  bopFilterDefinitions,
  { groupLabel: "Brand Customer" },
);

const brandOrderingPlatformSearch = brandOrderingPlatformFilters.find((fd) =>
  fd.id.endsWith(SEARCH_FILTER_ID),
);

assertPresence(brandOrderingPlatformSearch);

const filterDefinitions: FilterDefinition[] = [
  getSearchFilterDefinition({
    getResult: (value, context) => {
      const ors: SkuBrandOrderingPlatformFilter[] = [];

      const skuSearchResult = skuSearch.getResult?.(value, context);
      const brandOrderingPlatformSearchResult =
        brandOrderingPlatformSearch.getResult?.(value, context);

      if (skuSearchResult) ors.push(skuSearchResult);
      if (brandOrderingPlatformSearchResult)
        ors.push(brandOrderingPlatformSearchResult);

      if (ors.length === 0) return;

      return filterObj({ or: ors });
    },
  }),
  getStringFilterDefinition({
    id: "itemCode",
    label: "Item Code",
  }),
  getDateTimeFilterDefinition({
    id: "createdAt",
    label: "Added at",
    defaultVariant: "greaterThan",
  }),
  ...skuFilters,
  ...brandOrderingPlatformFilters,
];

export default filterDefinitions;
